import {
    addHostAccount,
    getSourceIdForUserIdentity,
    SourceAuthType,
    SourceType,
} from 'owa-account-source-list';
import { logUsage } from 'owa-analytics';
import type { MailboxType } from 'owa-client-types';

// Adds or updates the OWAConnectedAccount in the source list store
export function addConnectedAccount(
    userIdentity: string,
    accountUniqueId: string,
    accountState: number
) {
    const hostAccount = {
        sourceType: SourceType.Mailbox,
        authProviderType: SourceAuthType.OutlookDotCom,
        displayName: userIdentity,
        characteristics: {
            supportsCalendar: true,
            supportsContacts: false,
            supportsMail: false,
            supportsSettings: false,
        },
        mailbox: {
            type: 'UserMailbox' as MailboxType,
            name: userIdentity,
            displayName: userIdentity,
            emailAddress: userIdentity,
            loginAddress: userIdentity ?? '',
            userIdentity: userIdentity,
            accountUniqueId: accountUniqueId,
            routingHint: '',
            alternateId: '',
            imageUrl: '',
            profileUrl: '',
        },
        accountState: {
            connectedAccountState: accountState,
        },
    };

    const noAccountForUserIdentity = !getSourceIdForUserIdentity(userIdentity, true);
    if (noAccountForUserIdentity) {
        addHostAccount(hostAccount);
    }

    logUsage('addConnectedAccountToAccountSourceList', {
        noAccountForUserIdentity: noAccountForUserIdentity,
    });
}
